import type { Profile } from "../types";

export const profiles: Profile[] = [
  {
    id: "stratus-sarah",
    personId: "per-sarah",
    organisationId: "org-stratus",
    displayName: "Tom Edwin Makopiyo",
    role: "Programme Director",
    organisation: "Stratus Health",
    avatarInitials: "TM",
    landing: "/stratus",
    permissions: ["stratus.full"],
    group: "oversight",
  },
  {
    id: "stratus-sarah-okello",
    personId: "per-sarah-okello",
    organisationId: "org-stratus",
    displayName: "Sarah Okello",
    role: "Programme Manager",
    organisation: "Stratus Health",
    avatarInitials: "SO",
    landing: "/stratus",
    permissions: ["stratus.full"],
    description: "Matches the seeded backend login sarah.stratus@stratushealth.org",
    group: "oversight",
  },
  {
    id: "stratus-ai-operator",
    personId: "per-maya",
    organisationId: "org-stratus",
    displayName: "Maya Okello",
    role: "Programme Setup Lead",
    organisation: "Stratus Health",
    avatarInitials: "MO",
    landing: "/workspace/uganda-fire-stations/onboarding",
    permissions: ["stratus.full", "ai-upload.run"],
    description: "Used to demo the AI Procurement Plan Upload tool",
    group: "oversight",
  },
  {
    id: "funder-henrik",
    personId: "per-henrik",
    organisationId: "org-dif",
    displayName: "Henrik Lindqvist",
    role: "Programme Officer",
    organisation: "Danish Impact Fund",
    avatarInitials: "HL",
    landing: "/funder",
    permissions: ["funder.read", "funder.approve"],
    group: "funder",
  },
  {
    id: "funder-olivia",
    personId: "per-olivia",
    organisationId: "org-dif",
    displayName: "Olivia Andersen",
    role: "Investment committee",
    organisation: "Danish Impact Fund",
    avatarInitials: "OA",
    landing: "/funder",
    permissions: ["funder.read", "funder.approve", "funder.committee"],
    description: "Second authoriser for large milestone disbursements (multi-signature)",
    group: "funder",
  },
  {
    id: "stratus-verifier",
    personId: "per-david",
    organisationId: "org-stratus",
    displayName: "David Kirabo",
    role: "Monitoring & verification officer",
    organisation: "Stratus Health",
    avatarInitials: "DK",
    landing: "/stratus/exceptions",
    permissions: ["stratus.verify", "stratus.read"],
    description: "Independent verification · sampling and site visits",
    group: "oversight",
  },
  {
    id: "prime-james",
    personId: "per-james",
    organisationId: "org-eafe",
    displayName: "James Ssekandi",
    role: "Managing Director",
    organisation: "East Africa Fire Engineering Ltd",
    avatarInitials: "JS",
    landing: "/workspace/uganda-fire-stations/projects/fs-04-entebbe",
    permissions: ["contractor.lead", "ask.approve"],
    group: "contractor",
  },
  {
    id: "sub-naome",
    personId: "per-naome",
    organisationId: "org-kampala-electrical",
    displayName: "Naome Akello",
    role: "Project Manager",
    organisation: "Kampala Electrical Co.",
    avatarInitials: "NA",
    landing: "/workspace/uganda-fire-stations/projects/fs-04-entebbe/sub/sp-electrical",
    permissions: ["subcontractor.lead", "ask.approve.scoped"],
    group: "contractor",
  },
  {
    // Demo persona for the onboarding approval gate (§9): her org (org-eass) is
    // seeded `awaiting_gate`, so switching to her lands on the "awaiting approval"
    // screen (WorkspaceShell block) until a Stratus persona approves East African
    // Safety Systems in Approvals → Onboarding Approvals.
    id: "sub-ruth-pending",
    personId: "per-ruth",
    organisationId: "org-eass",
    displayName: "Ruth Nakato",
    role: "Managing Director",
    organisation: "East African Safety Systems (awaiting approval)",
    avatarInitials: "RN",
    landing: "/workspace/uganda-fire-stations",
    permissions: ["subcontractor.lead"],
    description: "Onboarding submitted — awaiting Stratus oversight approval",
    group: "contractor",
  },
  {
    id: "reporter-amina",
    personId: "per-amina",
    organisationId: "org-kampala-builders",
    displayName: "Amina Nakimuli",
    role: "Field Reporter",
    organisation: "Kampala Builders Co. · Entebbe site",
    avatarInitials: "AN",
    landing: "/reporter",
    permissions: ["reporter.field"],
    group: "reporter",
  },
  // TEMPORARILY HIDDEN — this persona's landing (/onboard/demo-invite-token-001)
  // points at an invite token that is NOT seeded in the backend, so selecting it
  // lands on "Invitation not found". Re-enable once a matching magic_link is
  // seeded (small migration: tokenhash = sha256("demo-invite-token-001") as a
  // prime_lead CONTRACTOR_ONBOARDING invite). Hidden for now so nobody clicks a
  // dead link mid-demo. To demo onboarding meanwhile: log in as the prime,
  // generate an invite via the §9.5 modal, and open that link.
  // {
  //   id: "onboarding-daniel",
  //   personId: "per-daniel",
  //   organisationId: "org-nextgen",
  //   displayName: "Daniel Mukasa",
  //   role: "Director of Operations",
  //   organisation: "NextGen Construction Ltd (onboarding)",
  //   avatarInitials: "DM",
  //   landing: "/onboard/demo-invite-token-001",
  //   permissions: ["onboarding.in-progress"],
  //   description: "Used to demo the Contractor Onboarding Wizard mid-flow",
  //   group: "onboarding",
  // },
  {
    id: "reporter-felix",
    personId: "per-felix",
    organisationId: "org-eafe",
    displayName: "Felix Wanyama",
    role: "Field Reporter",
    organisation: "East Africa Fire Engineering · Kampala Central",
    avatarInitials: "FW",
    landing: "/reporter",
    permissions: ["reporter.field"],
    group: "reporter",
  },
];

/** Optional eighth profile, surfaced only when dev mode is on. */
export const devProfile: Profile = {
  id: "philanthrify-ops",
  personId: "per-ops",
  organisationId: "org-philanthrify",
  displayName: "Philanthrify Ops",
  role: "Super admin",
  organisation: "Philanthrify",
  avatarInitials: "PO",
  landing: "/stratus",
  permissions: ["platform.superadmin"],
  description: "Dev-mode super admin",
  group: "other",
};

export const profilesById = Object.fromEntries(profiles.map((p) => [p.id, p]));

/** Display sections for the profile switcher. Spec §1 treats prime and sub
 *  contractor leads as distinct user types, but `profile.group` stays a single
 *  "contractor" value because visibility scoping keys off it — the split here
 *  is presentational only, derived from the lead permission. */
export type ProfileSection =
  | "oversight"
  | "funder"
  | "prime"
  | "sub"
  | "reporter"
  | "onboarding"
  | "other";

export const sectionOrder: ProfileSection[] = [
  "oversight",
  "funder",
  "prime",
  "sub",
  "reporter",
  "onboarding",
  "other",
];

export const sectionLabels: Record<ProfileSection, string> = {
  oversight: "Oversight",
  funder: "Funder",
  prime: "Prime contractor",
  sub: "Subcontractor",
  reporter: "Reporters",
  onboarding: "Onboarding",
  other: "Admin",
};

export function profileSection(p: Profile): ProfileSection {
  if (p.group === "contractor") {
    return p.permissions.includes("subcontractor.lead") ? "sub" : "prime";
  }
  return p.group;
}
